import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ClientLogoStripComponent } from '../../shared/components/client-logo-strip/client-logo-strip.component';

@Component({
  selector: 'app-association-management-companies-page',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule, ClientLogoStripComponent],
  templateUrl: './association-management-companies-page.component.html',
  styleUrl: './association-management-companies-page.component.scss'
})
export class AssociationManagementCompaniesPageComponent {
  painPoints = [
    {
      icon: 'hub',
      title: 'Too many disconnected systems',
      description: 'Member records, renewals, events, email lists, and reports drift apart when every organization uses different tools.'
    },
    {
      icon: 'rule_settings',
      title: 'Rebuilding the same workflows for every client',
      description: 'Teams lose time recreating the same workflows across societies, chapters, committees, and boards.'
    },
    {
      icon: 'summarize',
      title: 'Board reporting takes too long',
      description: 'Leaders need clean answers on membership, payments, events, and engagement—without another custom spreadsheet.'
    }
  ];

  operatingLayer = [
    { icon: 'groups', title: 'Member records', description: 'Centralize member profiles, statuses, directories, and custom fields for each organization.' },
    { icon: 'event', title: 'Events and meetings', description: 'Run registrations, attendance, agendas, abstracts, and paid events from the same platform.' },
    { icon: 'payments', title: 'Dues and payments', description: 'Collect renewals, event fees, donations, and other revenue in one place.' },
    { icon: 'campaign', title: 'Communication', description: 'Reach members with targeted updates and keep boards, committees, and staff aligned.' },
    { icon: 'monitoring', title: 'Reporting', description: 'Give staff and leadership clear visibility into members, revenue, and engagement.' },
    { icon: 'palette', title: 'Branding by organization', description: 'Each organization gets its own logo, colors, portal, and member-facing experience.' }
  ];

  workflow = [
    'Standardize setup across the organizations you manage',
    'Import member records without losing local context',
    'Run renewals, events, payments, and communication in one place',
    'Report to boards with current membership and revenue data'
  ];

}
